
import { Review, ReviewUI } from "@/types/supabase";

/**
 * Transform review data from Supabase format to UI format
 * @param reviewData Raw review data from Supabase
 * @returns Transformed review data for UI consumption
 */
export function transformReviewsForUI(reviewData: Review[]): ReviewUI[] {
  return reviewData.map((review) => {
    // Initialize with a default name
    let userName = "Anonymous User";
    let userEmail: string | null = null;
    
    // Extract profile data if available, handling potential error responses
    if (review.profiles && typeof review.profiles === 'object' && !('error' in review.profiles)) {
      const firstName = review.profiles.first_name || "";
      const lastName = review.profiles.last_name || "";
      userEmail = review.profiles.email || null;
      
      // Format the name properly with first name and last initial
      if (firstName || lastName) {
        if (firstName && lastName) {
          // Use full first name and last initial with a period
          userName = `${firstName} ${lastName.charAt(0)}.`;
        } else if (firstName) {
          userName = firstName;
        } else if (lastName) {
          userName = lastName;
        }
        
        // Ensure we don't have just spaces
        userName = userName.trim();
        
        if (!userName || userName === "") {
          userName = "Anonymous User";
        }
      }
    }
    
    return {
      id: review.id,
      userName,
      userEmail,
      rating: review.rating,
      comment: review.comment || "",
      date: new Date(review.created_at).toLocaleDateString(),
      isContactedProvider: review.contacted_provider,
      userId: review.user_id,
      isPublic: review.is_public,
      isReported: review.reported,
      reportedReason: review.reported_reason || "",
      providerId: review.provider_id
    };
  });
}
